import {Presenter} from '../../Support/with_presenter';
import {SnippetService} from '../../Network/SnippetService';
import {loadingResponse, NetworkResult} from '../../Network/NetworkResult';
import {FullSnippet, Snippet} from '../../Models/Snippet';
import {StrokesService} from '../../Network/StrokesService';
import {DownloadedIndoorWorkout} from '../../Models/DownloadedIndoorWorkout';
import {RangeInput} from '../../Models/RangeInput';

export class SnippetShowPresenter implements Presenter {
    public result: NetworkResult<FullSnippet> = loadingResponse();
    public downloadedIndoorWorkoutResult: NetworkResult<DownloadedIndoorWorkout> = loadingResponse();

    constructor(private id: number, private snippetService: SnippetService, private strokesService: StrokesService) {}

    public async mount(): Promise<void> {
        this.result = await this.snippetService.find(this.id);

        if (this.result.status === 'success') {
            this.downloadedIndoorWorkoutResult = await this.strokesService.forWorkoutId(
                this.result.data.publicWorkout.id,
            );
        }
    }

    public unmount(): void {
        /* Noop */
    }

    public toHighlightedRange(snippet: FullSnippet): RangeInput {
        return {
            start: snippet.startTime,
            end: snippet.endTime,
            predetermined: snippet,
        };
    }
}
